<div class="searchInputWrapper">
    <!--<mat-icon style="vertical-align: bottom;" width="18" height="18" title="search"
        [matTooltip]="selText()?.search" matTooltipClass="tooltipStyle">search</mat-icon>-->
    <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width: 250px;">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput #searchInput type="text" [(ngModel)]="searchText" (click)="$event.stopPropagation()" (input)="searchChange($event)"
               placeholder="{{ placeholderText() }}"/>
    </mat-form-field>
    @if (showButton()) {
        <button (click)="searchClick()" color="primary" mat-raised-button type="submit" id="confirmSearch">
            {{ selText()?.search }}
        </button>
    }
</div>